module.exports = __webpack_public_path__ + "img/network-wired.4e6f3c06.svg";